<template>
  <div class="pwd-wrapper">
    <van-popup 
      v-model="show" 
      @closed="closed" 
      round 
      position="center"
      :style="{ width: '90%', maxWidth: '26rem' }">
      
      <!-- 头部 -->
      <div class="pwd-header">
        <div class="close-btn" @click="closeGoOrder">
          <van-icon name="cross" size="1.3rem" color="#9a9a9a" />
        </div>
        <div class="title">请输入福利卡支付密码</div>
        <div class="placeholder"></div>
      </div>

      <!-- 内容区 -->
      <div class="pwd-content">
        <van-password-input 
          :class="{'pwd-error': !pasTrue}" 
          :value="payPwd" 
          gutter="0.6rem"
          :focused="showKeyboard" 
          @focus="showKeyboard = true" />
        
        <div class="msg-row">
          <div v-if="errorNum >= 5" class="error-text">{{ msg }}</div>
          <div v-else></div>
          <div v-if="errorNum < 5" class="forget-link" @click="forgetPass">忘记密码?</div>
        </div>
      </div>

      <!-- 底部按钮 -->
      <div class="pwd-footer">
        <button 
          class="submit-btn" 
          :class="{'reset-btn': errorNum >= 5}"
          @click="pwdContrast">
          {{ button }}
        </button>
      </div>
    </van-popup>

    <van-number-keyboard 
      v-model="payPwd" 
      :show="showKeyboard" 
      @blur="showKeyboard = false" 
      z-index="9999" />
  </div>
</template>

<script>
export default {
  name: "PutPassWord",
  props: {
    // 设为true时，验证通过后通过success事件传出密码，由业务方自行处理（后端校验模式）
    withPassword: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: true,
      pasTrue: true,
      showKeyboard: false,
      form: {
        userId: '',
        payPwd: '',
      },
      payPwd: '',
      msg: '',
      button: '确认支付',
      errorNum: 0,
    };
  },
  components: {},
  methods: {
    showKeyBoard() {
      this.showKeyboard = true
    },
    pwdContrast() {
      if (this.payPwd.length < 6) {
        this.$Toast('请正确输入密码');
        return;
      }
      this.form.payPwd = this.payPwd;
      // withPassword模式：直接把密码传回给父组件，由父组件统一处理（后端校验模式）
      if (this.withPassword) {
        this.$emit('success', this.payPwd);
        return;
      }
      if (this.errorNum < 5) {
        this.$api
          .pwdContrast(this.form)
          .then((res) => {
            if (res.code == 0) {
              this.$emit("success");
            } else {
              this.$Toast(res.msg)
            }
            this.pasTrue = res.data.flag
            this.errorNum = res.data.errorNum
            if (!this.pasTrue && this.errorNum > 4) {
              this.button = '重置密码'
            }
            this.msg = res.msg
          })
          .catch((err) => {
          });
      } else {
        this.forgetPass()
      }
    },
    closed() {
      this.showKeyboard = false;
      this.$emit("closed", false);
    },
    closeGoOrder() {
      this.showKeyboard = false;
      this.$emit("closed", false);
    },
    forgetPass() {
      this.form.payPwd = ''
      this.payPwd = ''
      this.$router.push({
        path: "/SetPassWord",
      });
    }
  },
  mounted() {
    window.scroll(0, 0);
    this.form.userId = localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo")).id : ''
  },
  computed: {},
  watch: {
    payPwd(value) {
      if (value.length > 6) {
        this.payPwd = this.payPwd.slice(0, 6)
      }
      if (value.length === 6) {
        setTimeout(() => {
          this.showKeyboard = false
        }, 200)
      }
    },
  },
};
</script>

<style lang='scss' scoped>
.pwd-wrapper {
  // 整体容器，无特殊样式
}

.pwd-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.2rem 1rem;
  border-bottom: 1px solid #f0f0f0;
  
  .close-btn {
    width: 2rem;
    cursor: pointer;
  }
  
  .title {
    font-size: 1.1rem;
    font-weight: 700;
    color: #2d3436;
    letter-spacing: 1px;
  }
  
  .placeholder {
    width: 2rem;
  }
}

.pwd-content {
  padding: 2rem 1.5rem 1rem;
  
  .msg-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 1rem;
    font-size: 0.85rem;
    
    .error-text {
      color: #e74c3c;
    }
    
    .forget-link {
      color: #636e72;
      cursor: pointer;
      
      &:hover {
        color: #e74c3c;
      }
    }
  }
}

// 密码框样式升级
::v-deep .van-password-input__security {
  li {
    border: 2px solid #e8e8e8;
    border-radius: 0.8rem;
    height: 3.2rem;
    transition: all 0.2s;
    background: #f6f8fb;
    
    &:focus-within {
      border-color: #e74c3c;
    }
  }
}

.pwd-error {
  ::v-deep .van-password-input__security li {
    border-color: #e74c3c;
    animation: shake 0.3s ease;
  }
}

@keyframes shake {
  0%, 100% { transform: translateX(0); }
  20%, 60% { transform: translateX(-4px); }
  40%, 80% { transform: translateX(4px); }
}

.pwd-footer {
  padding: 1rem 1.5rem 1.5rem;
  
  .submit-btn {
    width: 100%;
    height: 3.2rem;
    border: none;
    border-radius: 1.6rem;
    font-size: 1.05rem;
    font-weight: 700;
    color: #fff;
    background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);
    box-shadow: 0 6px 20px rgba(231, 76, 60, 0.3);
    transition: all 0.2s;
    cursor: pointer;
    
    &:active {
      transform: scale(0.96);
      opacity: 0.9;
    }
    
    &.reset-btn {
      background: linear-gradient(135deg, #636e72 0%, #2d3436 100%);
      box-shadow: 0 6px 20px rgba(45, 52, 54, 0.2);
    }
  }
}
</style>